<template>
  <div data-component-group="panels" data-component="role-select">
    <v-menu
      v-model="isMenuOpen"
      :close-on-content-click="false"
      :disabled="isDisabled"
    >
      <template #activator="{ props }">
        <span v-bind="props">
          <span :class="roleNameStyle">
            {{ roleName }}
          </span>
          <v-icon v-if="!isDisabled" class="menu-icon role-enabled"> keyboard_arrow_down </v-icon>
        </span>
      </template>

      <v-list class="menu-wrapper">
        <v-list-item
          v-for="role in roles"
          :key="role.name"
          class="menu-item"
          @click="onRoleSelect(item, role)"
        >
          <v-list-item-title :class="getMenuItemTitleStyle(item, role)">
            {{ role.name }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
  export default {
    props: {
      item: {
        type: Object,
        required: true,
      },
      updateItems: {
        type: Function,
        required: false,
      },
    },
    data() {
      return {
        isLoading: false,
        isMenuOpen: false,
      };
    },
    computed: {
      // See StatusSelect: a user with no role for this business arrives without
      // role.status, and the role change is persisted together with the membership
      // status, so there is nothing to send.
      membershipStatus() {
        return this.item.role?.status ?? {};
      },
      activeUser() {
        return this.$store.getters['auth/user'];
      },
      roles() {
        return this.$store.getters['users/subRoles'];
      },
      canUpdateRole() {
        return this.$ability.can('update-role', 'business-members');
      },
      isActiveUser() {
        return this.activeUser.id === this.item.id;
      },
      isDisabled() {
        return this.isActiveUser
          || !this.canUpdateRole
          || this.isLoading
          || !this.membershipStatus.id;
      },
      roleNameStyle() {
        return !this.isDisabled ? 'role-enabled' : 'role-disabled';
      },
      roleName() {
        return this.item.role?.slug ? this.$t(this.item.role.slug) : '';
      },
    },
    methods: {
      setBusinessUserSettings(query) {
        this.isLoading = true;

        return this.$store
          .dispatch('businessUsers/setSettings', query)
          .then((res) => {
            this.isLoading = false;
            this.updateItems();
            return res;
          })
          .catch((err) => {
            this.isLoading = false;
            return err;
          });
      },
      onRoleSelect(item, role) {
        this.isMenuOpen = false;
        const { id } = item;

        if (!role.code) {
          return null;
        }

        const query = {
          user: id,
          business_id: item.business.id,
          // `status` here is persisted as the per-business membership status (role_user.status),
          // so it must carry the membership status (role.status), not the global account_status.
          status: this.membershipStatus.id,
          role: role.code,
          setting: 'role',
        };

        this.setBusinessUserSettings(query);
      },
      getMenuItemTitleStyle(item, role) {
        return item.role.slug === role.code
          ? 'menu-item-title-active'
          : 'menu-item-title';
      },
    },
  };
</script>

<style lang="scss">
.menu-wrapper {
  padding: 0;

  .menu-item {
    padding: 0;
    min-height: 0;
    cursor: pointer;

    .menu-item-title {
      padding: 12px 24px 12px 8px;
      font-size: 14px;
      color: #424242;

      .v-theme--dark & {
        color: rgb(var(--v-theme-on-surface));
      }
    }

    .menu-item-title-active {
      padding: 12px 24px 12px 8px;
      font-size: 14px;
      color: #fb8c00;
      background-color: #fff1e6;
    }
  }
}

[data-component-group='panels'][data-component='role-select'] {
  font-size: 14px;
  font-weight: 500;

  .menu-icon {
    margin: 0 0 2px 12px;
    width: 12px;
  }

  .role-enabled {
    color: #424242;

    .v-theme--dark & {
      color: rgb(var(--v-theme-on-surface));
    }
  }

  .role-disabled {
    color: #9e9e9e;
  }
}
</style>
